import Comment from '../../components/calculation-form/components/form-items/comment'
import CalculationHeadingCell from '../../components/calculation-form/calculation-heading-cell'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const commentColumn: CalculationColumn = {
    dataIndex: 'comment',
    title: 'Наименование',
    editable: true,
    fixed: 'left',
    FormItem: <Comment />,
    render: (v, record) => {
        if (isCalculation(record)) {
            return <CalculationHeadingCell record={record} />
        } else {
            return record.comment
        }
    },
    onCell: record => {
        if (isCalculation(record)) {
            return { colSpan: 7, editable: false }
        } else {
            return { colSpan: 1, width: 120, style: { maxWidth: 120 }, editable: true }
        }
    },
}
